import React, { PureComponent } from 'react';
import { Tooltip } from 'reactstrap';

type Props = {
  target?: any,
  message: any
};

export class ToolTipHelp extends PureComponent<Props, State> {
  constructor(props) {
    super(props);
    this.toggle = this.toggle.bind(this);
    this.state = {
      tooltipOpen: false
    };
  }
  toggle() {
    this.setState({
      tooltipOpen: !this.state.tooltipOpen
    });
  }
  render() {
    return (
      <Tooltip
        className="info-tip"
        placement="top"
        isOpen={this.state.tooltipOpen}
        target={this.props.target}
        toggle={this.toggle}
        autohide={false}
      >
        {this.props.message}
      </Tooltip>
    );
  }
}
